import React from 'react'

import { useSelector } from 'react-redux'

import { Card, CardMediaContainer, Carousel, CardBody, CardHeader, Title, WHITE } from '@omnilert/components'

import ActionButton from '@components/action-button/action-button.component'
import BodyItem from '@components/body-item/body-item.component'
import CardAccordion from '@components/card-accordion/card-accordion.component'
import CardDropdown from '@components/card-dropdown/card-dropdown.component'
import CarouselContainer from '@components/carousel-container/carousel-container.component'
import UpdatedByContainer from '@components/updated-by-container/updated-by-container.component'

import useStyles from './noaa.style'

const Noaa = (props) => {
  const { message } = props

  const { collection, documentId } = message

  const document = useSelector(({ firestore: { data } }) => data[collection] && data[collection][documentId])

  const { actions, body, collapsable, header, media, updatedBy } = document

  const variant = header?.data?.variant

  const hasMultipleActions = actions?.length > 1

  const hasActions = !!actions?.data?.length

  const classes = useStyles({ hasMultipleActions })

  if (!document) return null

  return (
    <Card className={classes.card}>
      {header &&
        <CardHeader
          className={classes.cardHeader}
          type={variant}
        >
          <Title
            className={classes.title}
            color={WHITE}
            size='sm'
          >{header.data.title}
          </Title>
          <CardDropdown
            data={header?.data}
            direction='bottom'
          />
        </CardHeader>}

      {body &&
        <CardBody className={classes.cardBody}>
          {body.data.map((item, index) => (
            <BodyItem
              key={index}
              item={item}
            />
          ))}
        </CardBody>}

      {media && <CardMediaContainer
        className={classes.mediaContainer}
        media={media.data}
      />}

      {collapsable && <CardAccordion collapsable={collapsable} />}

      {updatedBy && <UpdatedByContainer data={updatedBy?.data} />}

      {hasActions && (
        <CarouselContainer>
          <Carousel
            className={classes.carousel}
          >
            {actions.data.map(data => (
              <ActionButton
                key={`carouselItem-${data.id}`}
                data={data}
                documentId={documentId}
              />
            ))}
          </Carousel>
        </CarouselContainer>
      )}
    </Card>
  )
}

export default Noaa
